import React from 'react';
import { cn } from '../lib/utils';

export interface CountBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  count: number | null | undefined;
  /** What the count measures, for example "open incidents". */
  label: string;
  /** Full count when the visible list is capped. */
  total?: number | null;
  /** @deprecated Counts always use the number-only pill; retained for callers. */
  compact?: boolean;
}

export function CountBadge({
  count,
  label,
  total,
  compact: _compact,
  className,
  ...props
}: CountBadgeProps) {
  return (
    <span
      {...props}
      data-compact={_compact || undefined}
      data-ui="count-badge"
      aria-label={
        props['aria-label'] ??
        `${count == null ? 'Unknown' : total == null ? count : `${count} of ${total}`} ${label}`
      }
      title={props.title ?? `${count ?? 'Unknown'}${total == null ? '' : ` of ${total}`} ${label}`}
      className={cn(
        'inline-flex h-5 min-w-5 w-auto shrink-0 self-center justify-self-start items-center justify-center whitespace-nowrap rounded-badge bg-status-neutral-bg px-1.5 font-body text-caption font-medium tabular-nums text-status-neutral-fg',
        className,
      )}
    >
      <span>{count == null ? 'Unknown' : count > 99 ? '99+' : count}</span>
    </span>
  );
}
